import { render } from "./ScheduleTestDrive.vue?vue&type=template&id=1df382ab&lang=true"
import script from "./ScheduleTestDrive.vue?vue&type=script&lang=js"
export * from "./ScheduleTestDrive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/ScheduleTestDrive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1df382ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1df382ab', __exports__)) {
    api.reload('1df382ab', __exports__)
  }
  
  module.hot.accept("./ScheduleTestDrive.vue?vue&type=template&id=1df382ab&lang=true", () => {
    api.rerender('1df382ab', render)
  })

}


export default __exports__